(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // --header-height is declared in CSS by announcement-bar.liquid. It used
      // to be measured and written here, which made it an inline style that no
      // stylesheet could override, and it only recalculated on load and at
      // 990px — so resizing across any other breakpoint left it stale.

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  let observer;
  const measureHeader = () => {
    if (!document.querySelector('.pb-home-hero')) return;
    const header = document.querySelector('.header-wrapper');
    const announcement = document.querySelector('.announcement-bar');
    const quote = document.querySelector('.pb-home-quote');
    const shortcuts = document.querySelector('.Collection-slider-mob');
    if (!header) return;
    if (observer) observer.disconnect();
    const update = () => {
      const height = Math.ceil(header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--pb-home-header-height', height + 'px');
      document.documentElement.style.setProperty('--pb-home-quote-height', (quote ? Math.ceil(quote.getBoundingClientRect().height) : 0) + 'px');
      document.documentElement.style.setProperty('--pb-home-shortcuts-height', (shortcuts ? Math.ceil(shortcuts.getBoundingClientRect().height) : 0) + 'px');
    };
    update();
    observer = new ResizeObserver(update);
    observer.observe(header);
    if (announcement) observer.observe(announcement);
    if (quote) observer.observe(quote);
    if (shortcuts) observer.observe(shortcuts);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measureHeader, { once: true });
  else measureHeader();
  document.addEventListener('shopify:section:load', measureHeader);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(measureHeader));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-home-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pb-featured-carousel')) {
  customElements.define('pb-featured-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pb-home-products__track');
      if (!this.track) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.items = Array.from(this.track.children);
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.count = this.querySelector('[data-count]');
      this.status = this.querySelector('[data-status]');
      this.controls = this.querySelector('.pb-home-products__controls');
      this.setAttribute('data-enhanced','');
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }, {...options, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.scroll(event.key === 'Home' ? 0 : this.track.scrollWidth);
        else this.move(event.key === 'ArrowRight' ? 1 : -1, 1);
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    scroll(left) {
      this.track.scrollTo({left, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    move(direction, amount) {
      const card = this.items[0];
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      const page = amount || Math.max(1,Math.round(this.track.clientWidth / step));
      this.scroll(this.track.scrollLeft + direction * page * step);
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = max < 2;
      this.previous.setAttribute('aria-disabled',String(this.track.scrollLeft < 2));
      this.next.setAttribute('aria-disabled',String(this.track.scrollLeft >= max - 2));
      const bounds = this.track.getBoundingClientRect();
      const visible = this.items.map((item,index) => ({index,rect:item.getBoundingClientRect()})).filter(item => item.rect.left >= bounds.left - 2 && item.rect.right <= bounds.right + 2);
      if (!visible.length) return;
      const first = visible[0].index + 1;
      const last = visible[visible.length - 1].index + 1;
      this.count.textContent = first + '–' + last + ' / ' + this.items.length;
      const label = this.status.dataset.template.replace('[first]',first).replace('[last]',last).replace('[total]',this.items.length);
      if (this.status.textContent !== label) this.status.textContent = label;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-home-quote"] && !Shopify.designMode) return;
  try {
    
(() => {
  let observer;
  const init = () => {
    if (observer) observer.disconnect();
    const hero = document.querySelector('.pb-home-hero');
    if (!hero || !document.querySelector('.pb-home-quote')) return;
    observer = new IntersectionObserver(entries => {
      document.body.classList.toggle('pb-opening-scrolled', !entries[0].isIntersecting);
    });
    observer.observe(hero);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-journal-article"]) return;
  try {
    
document.addEventListener('click', async (event) => {
  const videoLink = event.target.closest('.pb-journal__video-preview');
  if (videoLink) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const container = videoLink.closest('[data-journal-video]');
    const player = document.createElement('iframe');
    player.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(container.dataset.journalVideo) + '?autoplay=1&rel=0';
    player.title = container.dataset.videoTitle;
    player.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
    player.allowFullscreen = true;
    container.replaceChildren(player);
    player.focus();
  }
  const copyButton = event.target.closest('[data-journal-copy]');
  if (copyButton) {
    try {
      await navigator.clipboard.writeText(copyButton.dataset.journalCopy);
      copyButton.closest('nav').querySelector('[data-journal-copy-status]').textContent = copyButton.dataset.copiedLabel;
      copyButton.textContent = copyButton.dataset.copiedLabel;
    } catch (_) {
      const shareData = { url: copyButton.dataset.journalCopy, title: document.title };
      if (navigator.share) await navigator.share(shareData).catch(() => {});
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-refined-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pb-refined-browser')) {
  customElements.define('pb-refined-browser', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-sidebar-panel]');
      this.mount = this.querySelector('.pb-side__mount');
      this.dialog = this.querySelector('dialog');
      this.drawerContent = this.querySelector('.pb-side__drawer-content');
      this.openButton = this.querySelector('.pb-side__open');
      this.breakpoint = matchMedia('(max-width:1199px)');
      this.classList.add('is-enhanced');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const imageReady = image => {
        if (!image || image.complete || signal.aborted) return Promise.resolve();
        return new Promise(resolve => {
          const finish = () => {
            image.removeEventListener('load', finish);
            image.removeEventListener('error', finish);
            signal.removeEventListener('abort', finish);
            resolve();
          };
          image.addEventListener('load', finish, {once:true});
          image.addEventListener('error', finish, {once:true});
          signal.addEventListener('abort', finish, {once:true});
        });
      };
      const loadSecondaryImage = async (card, background = false) => {
        if (signal.aborted) return;
        const template = card?.querySelector('template[data-secondary-image]');
        if (!template) {
          const existing = card?.querySelector('.pb-refined-card__secondary');
          if (existing && !background) existing.fetchPriority = 'auto';
          return;
        }
        const image = template.content.querySelector('img').cloneNode(true);
        image.decoding = 'async';
        image.fetchPriority = background ? 'low' : 'auto';
        template.replaceWith(image);
        await imageReady(image);
        if (signal.aborted || !image.naturalWidth) return;
        if (image.decode) await image.decode().catch(() => {});
        if (!signal.aborted && image.isConnected && image.naturalWidth) image.classList.add('is-loaded');
      };
      this.addEventListener('pointerover', event => {
        if (event.pointerType === 'mouse' && matchMedia('(hover:hover) and (pointer:fine)').matches) {
          loadSecondaryImage(event.target.closest('.pb-refined-card'));
        }
      }, {signal});
      this.addEventListener('focusin', event => {
        const card = event.target.closest('.pb-refined-card');
        if (card?.matches(':focus-visible')) loadSecondaryImage(card);
      }, {signal});
      const hoverDevice = matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)');
      const connection = navigator.connection;
      const canPrepare = () => hoverDevice.matches && !connection?.saveData && !['slow-2g', '2g'].includes(connection?.effectiveType);
      if ('IntersectionObserver' in window && canPrepare()) {
        const nearby = new Set();
        const queue = new Set();
        let active = 0;
        let idle = null;
        const schedule = () => {
          if (idle !== null || active >= 2 || !queue.size || signal.aborted || document.hidden || !canPrepare()) return;
          const prepare = () => {
            idle = null;
            if (signal.aborted || document.hidden || !canPrepare()) return;
            while (active < 2 && queue.size) {
              const card = queue.values().next().value;
              queue.delete(card);
              if (!nearby.has(card) || !card.isConnected || !card.querySelector('template[data-secondary-image]')) continue;
              active++;
              loadSecondaryImage(card, true).finally(() => {
                active--;
                schedule();
              });
            }
          };
          idle = window.requestIdleCallback ? window.requestIdleCallback(prepare, {timeout:800}) : window.setTimeout(prepare, 120);
        };
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const card = entry.target;
            if (!entry.isIntersecting) {
              nearby.delete(card);
              queue.delete(card);
              return;
            }
            nearby.add(card);
            imageReady(card.querySelector('.pb-refined-card__image > img')).then(() => {
              if (!signal.aborted && nearby.has(card) && card.querySelector('template[data-secondary-image]')) {
                queue.add(card);
                schedule();
              }
            });
          });
        }, {rootMargin:'0px 0px 160px 0px'});
        const primaryImages = [...this.querySelectorAll('.pb-refined-card__image > img[loading="eager"]')];
        Promise.all(primaryImages.map(imageReady)).then(() => {
          if (!signal.aborted) this.querySelectorAll('.pb-refined-card').forEach(card => observer.observe(card));
        });
        document.addEventListener('visibilitychange', schedule, {signal});
        hoverDevice.addEventListener('change', schedule, {signal});
        signal.addEventListener('abort', () => {
          observer.disconnect();
          queue.clear();
          nearby.clear();
          if (idle !== null) {
            if (window.requestIdleCallback) window.cancelIdleCallback(idle);
            else window.clearTimeout(idle);
          }
        }, {once:true});
      }
      this.movePanel = () => {
        
        const inDrawer = this.breakpoint.matches || this.dataset.sidebar !== 'true';
        if (!inDrawer && this.dialog.open) this.dialog.close();
        (inDrawer ? this.drawerContent : this.mount).append(this.panel);
      };
      this.movePanel();
      this.breakpoint.addEventListener('change', this.movePanel, {signal});
      this.openButton.addEventListener('click', () => {
        this.openButton.setAttribute('aria-expanded', 'true');
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
      }, {signal});
      this.querySelector('[data-close-drawer]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('close', () => {
        this.openButton.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = this.previousOverflow || '';
        this.openButton.focus();
      }, {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, {signal});
      const filterForm = this.querySelector('.pb-side__filters');
      filterForm.addEventListener('submit', () => {
        const realTouch = filterForm.querySelector('[data-real-touch]');
        if (realTouch) filterForm.action = realTouch.checked ? filterForm.dataset.realTouchAdd : filterForm.dataset.realTouchRemove;
      }, {signal});
      this.querySelectorAll('[data-tag-link]').forEach(link => {
        const url = new URL(link.href);
        url.search = location.search;
        url.searchParams.delete('page');
        link.href = url.href;
      });
      this.querySelector('.pb-side__sort select').addEventListener('change', event => event.target.form.requestSubmit(), {signal});

    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow || '';
      }
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["replo-brand-logo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pb-press-strip')) {
  customElements.define('pb-press-strip', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      this.button = this.querySelector('button');
      this.setAttribute('data-enhanced', '');
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.setAttribute('aria-label', this.button.dataset[paused ? 'resume' : 'pause']);
      }, { signal: this.abort.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.toggleAttribute('data-visible', entries.some(entry => entry.isIntersecting));
        });
        this.observer.observe(this);
      } else this.setAttribute('data-visible', '');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
